/* eslint-disable no-async-promise-executor */
/* eslint-disable max-len */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-console */
// import imageCompression from 'browser-image-compression';
import { ref, onDisconnect } from 'firebase/database';
import { v4 } from 'uuid';
import { updateDocByDocumentId, userOnlineStatus } from './Firebase/firebaseQuery';
import { firebaseRealtimeDB } from './Firebase/useFirebase';
import { PRESENCE_ENUMS } from '../libs/enums/presenceEnums';
import imageCompression from 'browser-image-compression';
import { catchErr, configureStore, copyFilesTos3, getDataUrlFrmLocalSystm, newNewsFeedUploadFiles, objectUrlToFile } from '../libs/HelperContent';
import { useSelector } from 'react-redux';
import { uploadAttachment } from '../containers/CollaborationRevised/collaborationHelper';

export const getSendMessageBody = (
	{ uniqueId, roomInfo, inputText = '', isReplied, links, isLink,
		groupId, userInfo, replyMessage, attachments, notificationData, msgStatus, messageType,
		forwardGroupId, sendTo, mentionedList, linkPreviewData, peerData, platform = 'INLYNK'

	}) =>
{
	const currentTime = new Date().valueOf();

	const msgBody = {
		id                                                              : uniqueId,
		[peerData?.chatType === 'broadcast' ? 'broadcastId' : 'chatId'] : groupId,
		text                                                            : inputText?.trim() || '',
		mentionedList                                                   : mentionedList || [],
		attachments                                                     : Object.keys(attachments || {})?.length > 0
			? { ...attachments }
			: null,
		senderId          : userInfo?.userId,
		senderName        : userInfo?.firstName,
		timestamp         : currentTime,
		updatedAt         : currentTime,
		createdAt         : currentTime,
		sendTo            : [ ...sendTo ] || [],
		isEdited          : false,
		messageType       : messageType || PRESENCE_ENUMS.message,
		reactions         : [],
		notVisibleMembers : roomInfo?.blockedBy
			? roomInfo.blockedBy.map((blockedUser) => blockedUser.id)
			: [],
		notificationData : notificationData || null,
		repliedTo        : null,
		msgStatus        : msgStatus || 0,
		forwardGroupId   : forwardGroupId || null,
		links            : links || [],
		linkPreviewData  : linkPreviewData || null,
		isLink           : isLink || false,
		isBroadcast      : Boolean(peerData?.chatType === 'broadcast'),
		platform         : platform || 'INLYNK'

	};

	if (isReplied)
	{
		msgBody.repliedTo = {
			id          : replyMessage?.id,
			text        : replyMessage?.text,
			attachments : replyMessage?.attachments,
			senderId    : replyMessage?.senderId,
			timestamp   : replyMessage?.createdAt,
			senderName  : replyMessage?.senderName
		};
	}

	return msgBody;
};

export const getApiBody = ({ reqBody,
	apsBody = {}, dataBody = {}, type = '', isGroup = false, offer = null }) =>
{
	return {
		isGroup            : isGroup || false,
		message_model      : { ...reqBody },
		offer              : offer || null,
		notification_type  : type || PRESENCE_ENUMS.message,
		notification_model : {
			aps  : apsBody ? { ...apsBody } : null,
			data : dataBody ? { ...dataBody } : null
		}
	};
};

export const generateThumbnail = (file) =>
{
	return new Promise((resolve, reject) =>
	{
		try
		{
			let originalThumbnail = '';
			let compressedThumbnail = '';

			const videoElement = document.createElement('video');

			videoElement.src = URL.createObjectURL(file);

			videoElement.onloadeddata = () =>
			{
				videoElement.currentTime = 2; // Set the desired timestamp for thumbnail capture
			};

			videoElement.onseeked = async () =>
			{
				const canvas = document.createElement('canvas');

				canvas.width = videoElement.videoWidth;
				canvas.height = videoElement.videoHeight;
				const ctx = canvas.getContext('2d');

				ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

				const mimeType = 'image/jpeg';

				// Generate and display the original thumbnail
				canvas.toBlob(async (blob) =>
				{
					const fileName = 'thumbnail.jpg'; // You can customize the filename

					originalThumbnail = new File([ blob ], fileName, { type: mimeType });

					try
					{
						// Compress the original thumbnail
						const compressedFile = await imageCompression(blob, {
							maxSizeMB        : 0.001,
							maxWidthOrHeight : 50,
							useWebWorker     : true
						});
						// compressedThumbnail = URL.createObjectURL(compressedFile);

						compressedThumbnail = new File([ compressedFile ], 'compressed_thumbnail.jpg', { type: mimeType });

						console.log('compressedThumbnail', compressedThumbnail, originalThumbnail);
						resolve({
							compressedThumbnail,
							originalThumbnail
						});
					}
					catch (error)
					{
						console.error('Error compressing the thumbnail.', error);
						reject({
							compressedThumbnail : null,
							originalThumbnail   : null
						});
					}
				}, mimeType);
			};

			videoElement.onerror = () =>
			{
				reject({
					compressedThumbnail : null,
					originalThumbnail   : null
				});
			};
		}
		catch (err)
		{
			console.log('error in thumbnail generation:', err);
			reject({
				compressedThumbnail : null,
				originalThumbnail   : null
			});
		}
	});
};

// export const uploadAttachmentToS3AndGenratingUrls = (file) =>
// {
// 	// eslint-disable-next-line no-async-promise-executor
// 	return new Promise(async (resolve, reject) =>
// 	{
// 		let originalRes, compressedRes, fileUrl,
// 			compressedFileUrl, thumbnailRes, thumbnailUrl;

// 		try
// 		{
// 			const defaultFile = process.env.REACT_APP_PRESENCE_DEFAULT_URL;
// 			const cloudFrontDomain = process.env.REACT_APP_CLOUDFRONT_URL;

// 			if (file?.type.startsWith('image/'))
// 			{
// 				const compressionOptions = {
// 					maxSizeMB        : 0.001,
// 					maxWidthOrHeight : 50,
// 					useWebWorker     : true
// 				};

// 				// Compress and upload image
// 				const compressedFile = await imageCompression(file, compressionOptions);

// 				Promise.all([
// 					uploadPresenceAttachment(file),
// 					uploadPresenceAttachment(compressedFile)
// 				])
// 					.then(([ original, compressed ]) =>
// 					{
// 						originalRes = original;
// 						compressedRes = compressed;

// 						if (originalRes && compressedRes)
// 						{
// 							fileUrl = `${cloudFrontDomain}/${originalRes.key}`;
// 							compressedFileUrl = `${cloudFrontDomain}/${compressedRes.key}`;
// 						}
// 						resolve({
// 							originalRes,
// 							fileUrl,
// 							thumbnaillUrl,
// 							compressedFileUrl
// 						});
// 					})
// 					.catch((error) =>
// 					{
// 						console.error('Error compressing or uploading image:', error);
// 						toast.error('Error compressing or uploading image:', error.message);
// 						reject(error);
// 					});
// 			}
// 			else if (file?.type.startsWith('video/'))
// 			{
// 				const { compressedThumbnail, originalThumbnail } = await generateThumbnail(file);

// 				Promise.all([
// 					uploadPresenceAttachment(file),
// 					uploadPresenceAttachment(originalThumbnail || defaultFile),
// 					uploadPresenceAttachment(compressedThumbnail || defaultFile)
// 				])
// 					.then(([ original, thumbnail, compressed ]) =>
// 					{
// 						originalRes = original;
// 						thumbnailRes = thumbnail;
// 						compressedRes = compressed;

// 						fileUrl = `${cloudFrontDomain}/${originalRes.key}`;
// 						thumbnaillUrl = `${cloudFrontDomain}/${thumbnailRes.key}`;
// 						compressedFileUrl = `${cloudFrontDomain}/${compressedRes.key}`;

// 						resolve({
// 							originalRes,
// 							fileUrl,
// 							thumbnaillUrl,
// 							compressedFileUrl
// 						});
// 					})
// 					.catch((err) =>
// 					{
// 						console.error('Error uploading video:', err);
// 						toast.error('Error uploading video:', err.message);
// 						reject(err);
// 					});
// 			}
// 			else
// 			{
// 				// For non-image files, only upload the original
// 				uploadPresenceAttachment(file)
// 					.then((original) =>
// 					{
// 						originalRes = original;
// 						fileUrl = `${cloudFrontDomain}/${originalRes.key}`;

// 						resolve({
// 							originalRes,
// 							fileUrl,
// 							thumbnaillUrl,
// 							compressedFileUrl
// 						});
// 					})
// 					.catch((err) =>
// 					{
// 						console.error('Error uploading file:', err);
// 						toast.error('Error uploading file:', err.message);
// 						reject(err);
// 					});
// 			}
// 		}
// 		catch (err)
// 		{
// 			console.log('Error in uploadAttachmentToS3AndGenratingUrls:', err);
// 			reject(err);
// 		}
// 	});
// };

export const uploadMediaToS3FmrChat = async (fileObj, userData) =>
{
	return new Promise(async (resolve, reject) =>
	{
		let originalRes, compressedRes, fileUrl, compressedFileUrl, thumbnailRes, thumbnailUrl;

		try
		{
			const defaultFile = process.env.REACT_APP_PRESENCE_DEFAULT_URL;
			const folderPath = `${userData?.companyId}/collaboration`;

			if (fileObj?.type?.startsWith('image/'))
			{
				const compressionOptions = {
					maxSizeMB        : 0.01,
					maxWidthOrHeight : 50,
					useWebWorker     : true
				};

				try
				{
					const compressedFile = await imageCompression(fileObj, compressionOptions);
					const [ original, compressed ] = await Promise.all([
						uploadAttachment([ fileObj ], 'presence/media'),
						uploadAttachment([ compressedFile ], 'presence/media')
					]);

					originalRes = original?.[0];
					compressedRes = compressed?.[0];

					if (originalRes && compressedRes)
					{
						fileUrl = originalRes?.url;
						compressedFileUrl = compressedRes?.url;
					}

					resolve({ originalRes, fileUrl, thumbnailUrl, compressedFileUrl });
				}
				catch (err)
				{
					catchErr(err);
					reject(err);
				}
			}
			else if (fileObj?.type.startsWith('video/'))
			{
				try
				{
					const { compressedThumbnail, originalThumbnail } = await generateThumbnail(fileObj);
					const [ original, thumbnail, compressed ] = await Promise.all([
						uploadAttachment([ fileObj ], 'presence/media'),
						uploadAttachment([ originalThumbnail || defaultFile ], 'presence/media'),
						uploadAttachment([ compressedThumbnail || defaultFile ], 'presence/media')
					]);

					originalRes = original[0];
					thumbnailRes = thumbnail[0];
					compressedRes = compressed[0];

					fileUrl = originalRes?.url;
					thumbnailUrl = thumbnailRes?.url;
					compressedFileUrl = compressedRes?.url;

					resolve({ originalRes, fileUrl, thumbnailUrl, compressedFileUrl });
				}
				catch (err)
				{
					catchErr(err);
					reject(err);
				}
			}
			else
			{
				try
				{
					if (fileObj?.url)
					{
						originalRes = await copyFilesTos3(fileObj);
					}
					else
					{
						const [ original ] = await uploadAttachment([ fileObj ], 'presence/media');

						originalRes = original;
					}

					fileUrl = originalRes?.url;

					// commented below code, thumbnail url for docs not required

					// const imagePath = fileObj?.type?.split('/')[0] === 'application' ? `/documents/${fileObj?.name?.split('.')?.pop()}.png` : '/documents/txt.png';
					// const generateBlobDoc = await getDataUrlFrmLocalSystm(imagePath);
					// const fileData = await objectUrlToFile(generateBlobDoc, fileObj?.name);
					// const customPrefix = { public: `${userData?.companyId}/collaboration` };

					// compressedFileUrl = await configureStore(fileData, customPrefix);

					resolve({ originalRes, fileUrl, thumbnailUrl, compressedFileUrl });
				}
				catch (err)
				{
					console.log(err, '------------------err');
					catchErr(err);
				}
			}
		}
		catch (err)
		{
			catchErr(err);
			console.log('Error in thumbnail or media upload:', err);
			reject(err);
		}
	});
};

export const checkMediaPermissions = async () =>
{
	const permissionObj = {
		isAudio : false,
		isVideo : false
	};

	// Try Permissions API (for Chrome, Edge, etc.)
	if (navigator?.permissions)
	{
		try
		{
			const audioPermission = await navigator.permissions.query({ name: 'microphone' });

			console.log('audioPermission', audioPermission);
			const videoPermission = await navigator.permissions.query({ name: 'camera' });

			permissionObj.isAudio = audioPermission.state === 'granted';
			permissionObj.isVideo = videoPermission.state === 'granted';

			console.log('Permissions API results:', permissionObj);

			return permissionObj;
		}
		catch (error)
		{
			console.warn('Permissions API query failed:', error);
		}
	}

	// Fallback for Safari and unsupported browsers
	const checkStream = async (constraints) =>
	{
		try
		{
			const stream = await navigator.mediaDevices.getUserMedia(constraints);

			stream.getTracks().forEach((track) => track.stop()); // Stop stream immediately

			return true;
		}
		catch (error)
		{
			console.warn('Media access denied or failed:', error);

			return false;
		}
	};

	// Check audio and video permissions via getUserMedia()
	permissionObj.isAudio = await checkStream({ audio: true });
	permissionObj.isVideo = await checkStream({ video: true });

	console.log('Final permission results:', permissionObj);

	return permissionObj;
};

export const getConectedDevices = async (type) =>
{
	const connectedDevices = await navigator.mediaDevices?.enumerateDevices();

	console.log('connectedDevicesconnectedDevices', connectedDevices);
	const devices = connectedDevices?.filter((device) => device.kind === type);

	return devices;
};

export const formatTime = (seconds) =>
{
	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = seconds % 60;

	return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

export const updateDeviceData = async (statusData, userId) =>
{
	try
	{
		const deviceData = sessionStorage.getItem('deviceData');

		let parseDeviceData;

		if (deviceData)
		{
			parseDeviceData = JSON.parse(deviceData);
		}
		else
		{
			parseDeviceData = {
				deviceId : v4()
			};
		}

		await userOnlineStatus(userId, parseDeviceData?.deviceId, statusData);
		sessionStorage.setItem('deviceData', JSON.stringify({ deviceId: parseDeviceData?.deviceId, ...statusData }));
		const userStatusataRef = ref(firebaseRealtimeDB, `UserDeviceStatus/${userId}/${parseDeviceData?.deviceId}`);
		const onStatusDisconnectRef = onDisconnect(userStatusataRef);

		onStatusDisconnectRef.cancel();
		onStatusDisconnectRef.remove();
	}
	catch (err)
	{
		console.log('error===', err);
	}
};